import React from "react";
import _ from "lodash";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function TruckTypeDetails({ label, type, isEditable }) {
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                selectedValue={type}
                isEditable={isEditable}
            />
        </EuiFlexItem>
    );
}
